import { useCartState } from '@jane/monolith/components/cart/cartFacade/useCartState';
import { getCartLineItems } from '@jane/monolith/lib/getCartLineItems';

export const useGetCartLineItems = () => {
  const { cart } = useCartState();

  return getCartLineItems({
    cart: cart ?? {},
    posCartTotals: cart?.pos_cart.totals ?? undefined,
    tipAmount: cart?.tip_amount ?? 0,
  });
};
